import validate from "/var/www/html/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45path_45parser_45global from "/var/www/html/middleware/00.path-parser.global.ts";
export const globalMiddleware = [
  validate,
  _00_45path_45parser_45global
]
export const namedMiddleware = {
  admin: () => import("/var/www/html/middleware/admin.ts"),
  auth: () => import("/var/www/html/middleware/auth.ts"),
  guest: () => import("/var/www/html/middleware/guest.ts")
}